let initialized = false;

export default {
  /* eslint-disable */
  init(conversion_id) {
    !(function (c, t) {
      ((t = c.createElement("script")).type = "text/javascript"),
        (t.async = !0),
        (t.onload = function () {
          window.dataLayer = window.dataLayer || [];
          if (!window.gtag) {
            window.gtag = function () {
              dataLayer.push(arguments);
            };
          }
          gtag("js", new Date());
          gtag("config", conversion_id, { allow_enhanced_conversions: true });
        }),
        (t.src = `https://www.googletagmanager.com/gtag/js?id=${conversion_id}`),
        c.getElementsByTagName("head")[0].appendChild(t);
    })(document);
    /* eslint-enable */
    initialized = true;
  },
  track(send_to, transaction_id, total_price, user_data) {
    if (!window.gtag) return;
    /* eslint-disable */
    gtag("set", "user_data", user_data);
    gtag("event", "conversion", {
      send_to: send_to,
      transaction_id: transaction_id,
      value: total_price,
      currency: "USD",
    });
    /* eslint-enable */
  },
};
